import { useSelector } from 'react-redux';
import { excludeTariffsMobileLanding } from 'reactApp/appHelpers/featuresHelpers/features/excludeTariffsMobileLanding';
import { isAllowedPriceDiffOverquota, isPriceDifferentiation } from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import { pricesWithoutDiscountAB } from 'reactApp/appHelpers/featuresHelpers/features/quotaLandingPrices';
import { usePriceWithoutDiscount } from 'reactApp/appHelpers/priceWithoutDiscount.hook';
import { BillingPersonalizationSelectors } from 'reactApp/modules/billingPersonalization/billingPersonalization.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import { skipBillingPersonalization } from 'reactApp/sections/QuotaLanding/billingPersonalizationQuotaLandingSegment';
import {
    getMultiTariffMobileBillingPersonalization,
    getMultiTariffMobilePriceDiff,
    getMultiTariffMobileProductsSpacesListByTab,
    getMultiTariffMobileProductsSpacesListByTabForAnonymous,
    getMultiTariffMobileProductsWithoutDiscounts,
} from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.selectors';
import type { RootState } from 'reactApp/store';

export const useGetProductsSpaces = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isOverquota = useSelector(isCloudOrMailOrApiOverQuota);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isAnonymous = useSelector(UserSelectors.isAnonymous);
    const isPricesWithDiscount = usePriceWithoutDiscount();

    const isBillingPersonalisationEnabled = useSelector(BillingPersonalizationSelectors.isBillingPersonalisationEnabledMobile);
    const skipPersonalization = skipBillingPersonalization();

    const productsSpaces = useSelector((state: RootState) => {
        // [CLOUDWEB-20022][Touch] Добавить мультитарифный лендинг на анонимов
        if (isAnonymous) {
            return getMultiTariffMobileProductsSpacesListByTabForAnonymous(state);
        }

        if (pricesWithoutDiscountAB !== 'a' && isPricesWithDiscount) {
            return getMultiTariffMobileProductsWithoutDiscounts(state);
        }
        // tempexp_19915-start
        if (isBillingPersonalisationEnabled && !skipPersonalization) {
            return getMultiTariffMobileBillingPersonalization(state);
        }
        // tempexp_19915-end

        // tempexp_19870-start
        if (!isCorpUser && !isPaidUser && isPriceDifferentiation && (!isOverquota || (isAllowedPriceDiffOverquota && isOverquota))) {
            return getMultiTariffMobilePriceDiff(state);
        }
        // tempexp_19870-end

        // !IMPORTANT. Не расширяем оригинальный селектор. Если для эксперимента нужны другие тарифы/цены - заводим отдельный.
        return getMultiTariffMobileProductsSpacesListByTab(state);
    });

    // tempexp_20853-start
    if (excludeTariffsMobileLanding?.quotas?.length) {
        const { quotas } = excludeTariffsMobileLanding;
        return {
            ...productsSpaces,
            spaces: productsSpaces.spaces.filter((space) => !quotas.includes(space)),
            products: Object.fromEntries(Object.entries(productsSpaces.products).filter(([space]) => !quotas.includes(Number(space)))),
        };
    }
    // tempexp_20853-end

    return productsSpaces;
};
